"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _core.makeStyles)(theme => ({
  input: {
    '& .MuiFormLabel-root.Mui-focused': {
      color: theme.palette.text.secondary
    },
    '& .MuiInputBase-input': {
      cursor: 'not-allowed'
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.action.hover,
      '&:hover fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.23)'
      },
      '&.Mui-focused fieldset': {
        border: 'solid 1px rgba(0, 0, 0, 0.23)'
      }
    }
  }
}));

/**
 * Componente para entrada de texto
 */
const TextInput = _ref => {
  let {
    color,
    disabled,
    helperText,
    error,
    fullWidth,
    label,
    id,
    multiline,
    name,
    onBlur,
    onChange,
    required,
    value,
    readOnly,
    rows,
    size,
    className,
    inputType,
    startAdornment: StartAdornment,
    endAdornment: EndAdornment
  } = _ref;
  const defaultClassName = useStyles();
  const readOnlyText = 'Campo não editável';
  return /*#__PURE__*/_react.default.createElement(_core.TextField, {
    color: color,
    size: size,
    style: {
      width: (0, _utils.checkSize)(size)
    },
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    helperText: readOnly ? readOnlyText : helperText,
    id: id,
    label: label,
    multiline: multiline,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    required: required,
    rows: rows,
    variant: "outlined",
    type: "text",
    value: value,
    InputProps: {
      readOnly,
      startAdornment: StartAdornment,
      endAdornment: EndAdornment,
      type: inputType
    },
    className: `${readOnly ? defaultClassName.input : null} ${className}`
  });
};
exports.TextInput = TextInput;
TextInput.propTypes = {
  /**
   * Tamanho do componente
   */
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'full']),
  /**
   * Cor do campo
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']).isRequired,
  /**
   * Se `true` o campo é desabilitado
   */
  disabled: _propTypes.default.bool,
  /**
   * Se `true` o campo fica no estado de erro
   */
  error: _propTypes.default.bool,
  /**
   * Propriedade para deixar o campo com largura máxima
   */
  fullWidth: _propTypes.default.bool,
  /**
   * Texto de auxílio de preechimento do campo ou mensagem de erro
   */
  helperText: _propTypes.default.string,
  /**
   * Atributo `id` do componente
   */
  id: _propTypes.default.string,
  /**
   * Label do componente
   */
  label: _propTypes.default.string,
  /**
   * Atributo `name` do input
   */
  name: _propTypes.default.string,
  /**
   * Função executada  quando um elemento perde foco
   */
  multiline: _propTypes.default.bool,
  /**
   * Atributo para exibir o input com várias linhas
   */
  onBlur: _propTypes.default.func,
  /**
   * Função executada quando valor é mudado
   */
  onChange: _propTypes.default.func,
  /**
   * Se `true` o campo se mostra como obrigatório
   */
  required: _propTypes.default.bool,
  /**
   * Valor digitado no campo
   */
  rows: _propTypes.default.number,
  /**
   * Número de linhas a ser exibido no modo multiline
   */
  value: _propTypes.default.string,
  /**
   * Se `true` o campo é somente para leitura e não editável
   */
  readOnly: _propTypes.default.bool,
  /**
   * Função geradora de estilos
   */
  className: _propTypes.default.string,
  /**
   * componente de adorno que vai no começo
   *
   * Aceita IconButton [Exemplo](https://v4.mui.com/components/text-fields/#input-adornments)
   *
   * ### Exemplo
   *
   * ```js
   * <TextInput {...props} startAdornment={<InputAdornment>Kg</InputAdornment>} />
   * ```
   */
  startAdornment: _propTypes.default.func,
  /**
   * componente de adorno que vai no final
   *
   * Aceita IconButton [Exemplo](https://v4.mui.com/components/text-fields/#input-adornments)
   *
   * ### Exemplo
   *
   * ```js
   * <TextInput {...props} endAdornment={<InputAdornment>Kg</InputAdornment>} />
   * ```
   */
  endAdornment: _propTypes.default.func,
  /**
   * Tipo de input
   */
  inputType: _propTypes.default.oneOf(['text', 'password'])
};
TextInput.defaultProps = {
  size: 'sm',
  error: false,
  disabled: false,
  fullWidth: false,
  helperText: null,
  id: null,
  label: null,
  multiline: false,
  name: null,
  onBlur: null,
  onChange: null,
  required: false,
  rows: null,
  value: '',
  readOnly: false,
  className: null,
  startAdornment: null,
  endAdornment: null,
  inputType: 'text'
};